/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import i18next from 'i18next';

import { SupportedLanguages, DefaultLanguage } from './constants';

export default class Language {
  i18n: typeof i18next;

  constructor(i18n: typeof i18next) {
    this.i18n = i18n;
  }

  private static getBrowserLanguage(): string {
    try {
      const { locale } = new Intl.DateTimeFormat().resolvedOptions();
      const [language] = locale.split('-');
      return language;
    } catch (err) {
      return navigator.language;
    }
  }

  private static getUrlLanguage(): string | null {
    let urlLang = null;
    const result = new RegExp('[?&]lang=([^&#]*)').exec(window.location.href);
    if (result) {
      [, urlLang] = result;
    }
    return urlLang;
  }

  public static isSupportedLanguage(language: string): boolean {
    const languageCodes = Object.values(SupportedLanguages);
    return languageCodes.includes(language);
  }

  public static determineLanguage(providedLanguage?: string): string {
    let language = DefaultLanguage;

    const browserLanguage = Language.getBrowserLanguage();
    if (browserLanguage && Language.isSupportedLanguage(browserLanguage)) {
      language = browserLanguage;
    }

    if (providedLanguage && Language.isSupportedLanguage(providedLanguage)) {
      language = providedLanguage;
    }

    const urlLanguage = Language.getUrlLanguage();
    if (urlLanguage && Language.isSupportedLanguage(urlLanguage)) {
      language = urlLanguage;
    }

    return language;
  }

  public setLanguage(providedLanguage?: string): void {
    this.i18n.changeLanguage(Language.determineLanguage(providedLanguage));
  }
}
